export default "__VITE_ASSET__IOR9jCrx__"